const FilterData = [
  {
    filterField: "accountHolderTypes",
    filterLabel: "Client type",
    filterProperties: [
      {
        filterDisplay: "All",
        fieldsToShow: "All",
      },
      {
        filterDisplay: "Individual",
        fieldsToShow: "INDIVIDUAL",
      },
      {
        filterDisplay: "Joint",
        fieldsToShow: "JOINT",
      },
      {
        filterDisplay: "Charity",
        fieldsToShow: "CHARITY",
      },
      {
        filterDisplay: "Trust",
        fieldsToShow: "TRUST",
      },
      {
        filterDisplay: "Corporate - SME",
        fieldsToShow: "SME",
      },
      {
        filterDisplay: "Corporate - other",
        fieldsToShow: "CORPORATE",
      },
    ],
  },
];

export default FilterData;
